/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureCspCustomer extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureCspCustomer");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureCspCustomer.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureCspCustomer>): ServiceAccountNativeDetailsForAzureCspCustomer {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureCspCustomer(), model);
        ServiceAccountNativeDetailsForAzureCspCustomer.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureCspCustomer>): ServiceAccountNativeDetailsForAzureCspCustomer {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureCspCustomer.newInstance(<ServiceAccountNativeDetailsForAzureCspCustomer> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureCspCustomer) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureCspCustomer.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureCspCustomer): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureCspCustomer.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Customer Id
     */
    customer_id: string;

    /**
     * Customer Name
     */
    customer_name: string;

}
